import { Link, useLocation } from "react-router-dom";
import useHasFeaturedJobs from "@/lib/useHasFeaturedJobs";

export function PublicNav() {
  const { pathname } = useLocation();
  const hasJobs = useHasFeaturedJobs();
  const link = (to, label) => (
    <Link
      to={to}
      className={`hover:text-[#09090B] transition-colors ${pathname === to ? "text-[#09090B]" : ""}`}
    >
      {label}
    </Link>
  );
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/80 backdrop-blur-xl border-b border-black/10">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-6 w-6 bg-primary" />
          <span className="font-heading font-black tracking-tight">INNOVATION TALENT PARTNERS</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          {link("/for-clients", "For Clients")}
          {link("/for-candidates", "For Candidates")}
          {link("/for-recruiters", "For Recruiters")}
          {link("/advisory-services", "Advisory Services")}
          {link("/vc-platform", "VC Platform")}
          {hasJobs && link("/featured-jobs", "Featured Jobs")}
          {link("/our-story", "Our Story")}
        </nav>
        <Link
          to="/login"
          data-testid="nav-signin-btn"
          className="text-sm font-medium px-5 py-2 bg-[#09090B] text-white hover:bg-primary transition-colors duration-150"
        >
          Sign In
        </Link>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="border-t border-black/10 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="h-5 w-5 bg-primary" />
          <span className="font-heading font-black text-sm tracking-tight">INNOVATION TALENT PARTNERS</span>
        </div>
        <div className="flex items-center gap-6 text-xs text-muted-foreground">
          <Link to="/for-clients" className="hover:text-[#09090B]">For Clients</Link>
          <Link to="/for-candidates" className="hover:text-[#09090B]">For Candidates</Link>
          <Link to="/for-recruiters" className="hover:text-[#09090B]">For Recruiters</Link>
          <Link to="/advisory-services" className="hover:text-[#09090B]">Advisory Services</Link>
          <Link to="/vc-platform" className="hover:text-[#09090B]">VC Platform</Link>
          <Link to="/our-story" className="hover:text-[#09090B]">Our Story</Link>
          <Link to="/login" className="hover:text-[#09090B]">Sign In</Link>
        </div>
        <p className="text-xs text-muted-foreground">© 2026 · Built for the innovation economy.</p>
      </div>
    </footer>
  );
}
